import PageLayout from "@/components/layout/PageLayout";
import Pricing from "@/components/sections/Pricing";
import Savings from "@/components/sections/Savings";

export default function PricingPage() {
  return (
    <PageLayout testId="pricing-page">
      <Pricing />
      <Savings />
    </PageLayout>
  );
}
